import React from 'react';

const Container = ({ children }) => {
  return (
    <div
      className='container-custom'
    >
      {children}
    </div>
  );
};

export default Container;
